import React from "react";
import { useZones } from "../hooks/useZones";

/**
 * Zone picker for TP/driver onboarding — replaces manually typing a ZIP-code
 * list. Selecting zones expands to their ZIP codes on submit via
 * `zipCodesForZoneIds`, so the backend's `service_zip_codes` contract is
 * unchanged.
 */
export function zipCodesForZoneIds(zones, selectedIds) {
  const set = new Set();
  zones.filter((z) => selectedIds.includes(z.id)).forEach((z) => (z.zip_codes || []).forEach((zip) => set.add(zip)));
  return Array.from(set);
}

export function ZonePicker({ selectedIds, onChange, testId = "zone-picker" }) {
  const { zones, loading } = useZones();

  const toggle = (id) => {
    onChange(selectedIds.includes(id) ? selectedIds.filter((x) => x !== id) : [...selectedIds, id]);
  };

  if (loading) return <div className="text-sm text-gray-500">Loading zones…</div>;

  if (zones.length === 0) {
    return <div className="text-sm text-gray-500">No zones configured yet — enter ZIP codes manually below.</div>;
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid={testId}>
      {zones.map((z) => {
        const checked = selectedIds.includes(z.id);
        return (
          <label
            key={z.id}
            data-testid={`${testId}-option-${z.name.toLowerCase()}`}
            className={`flex items-center justify-between gap-2 rounded-lg border px-3 py-2 text-sm cursor-pointer transition-colors ${
              checked ? "border-emerald-500 bg-emerald-50 text-emerald-700" : "border-gray-200 bg-white text-gray-700"
            }`}
          >
            <span className="flex items-center gap-2">
              <input type="checkbox" checked={checked} onChange={() => toggle(z.id)} className="accent-emerald-600" />
              {z.name}
            </span>
            <span className="text-xs text-gray-400">{(z.zip_codes || []).length} ZIPs</span>
          </label>
        );
      })}
    </div>
  );
}
